import * as types from '../actions/zoom-actions-types';


const SET_ZOOM_CALL_CURRENTLY_ACTIVE_INITIAL_STATE = {
	isLoading: false,
	activeDsrZoomCall: "",
	error: '',
};

export function setZoomCallCurrentlyActiveReducer(state = SET_ZOOM_CALL_CURRENTLY_ACTIVE_INITIAL_STATE, action) {
	switch (action.type) {
		case types.SET_ZOOM_CALL_CURRENTLY_ACTIVE:
			return { ...state, isLoading: false, activeDsrZoomCall: action.payload };
		default:
			return state;
	}
}